import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UserRound, CircleUserRound } from 'lucide-react';

import styles from './Navbar.module.scss';


const Navbar = () => {

    return (
        <nav className={styles.navbar}>
          <div className={styles.navbarContainer}>
            <p><img className={styles.logo} src="test4.png" alt="" width="50px"/></p>
            <h1><Link to="/" className={styles.titre}>Scriptales solutions</Link></h1>
            <ul className={styles.navMenu}>
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">À Propos</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
            {/* <p className={styles.icon}><CircleUserRound size={30} /></p> */}
          </div>
        </nav>
    );
}

export default Navbar;